import * as React from 'react'
import { Loader } from '../'

const LoaderWrapper = ({
  loading,
  loadOnlyApi = false,
  isLoading = null,
  isSuccess,
  isError,
  error,
  children,
}) => {
  if (isLoading || isSuccess || isError) {
    if (isError) {
      console.log('Error from Loader Component =================== ', error)
    }
    return (
      <>
        {isLoading && <Loader />}
        {/* { isSuccess && !loadOnlyApi && <>{children}</> } */}
        {isSuccess && !loadOnlyApi && <>{children}</>}
        {isError && <>{error}</>}
      </>
    )
  } else {
    return <>{loading ? <Loader /> : !loadOnlyApi && <>{children}</>}</>
  }
}
export default LoaderWrapper
